module.exports = __webpack_public_path__ + "img/scope-jurisprudence.96d72034.png";